import { createRouter, createWebHashHistory, createWebHistory, useRoute } from 'vue-router'

import App from "@/services/App";
// import Base from "@/layouts/Base.vue";
import Empty from "@/layouts/Empty.vue";
import Dashboard from "@/layouts/Dashboard.vue";

// import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Logout from "@/views/Logout.vue";
import Forgot from '@/views/Forgot.vue';
import Register from '@/views/Register.vue';
import NotFound from '@/views/NotFound.vue';


import ProjectStatus from '@/components/Projects/ProjectStatus.vue';

import Cache from "@/services/Cache";
import Events from "@/services/Emitter";

import Home from '@/components/Dashboard/Home.vue';

import DashRoutes from "./DashRoutes";

import ClockRoutes from "./ClockRoutes";
import TimeRoutes from "./TimeRoutes";
import PartRoutes from './PartRoutes';
import PMRoutes from './PMRoutes';
import ExpenseRoutes from './ExpenseRoutes';
import TechRoutes from './TechRoutes';
import NoteRoutes from './NoteRoutes';
import ClientRoutes from './ClientRoutes';
import JobRoutes from './JobRoutes';
import MileageRoutes from './MileageRoutes';
import StaffRoutes from "./StaffRoutes";

import ProjectRoutes from "./ProjectRoutes";
import ReportRoutes from "./ReportRoutes";
import CalendarRoutes from "./CalendarRoutes";

// LAZY LOAD: component: () => import('../views/... .vue'),

// store window history
const  historyLength = window.history.length;

const router = createRouter({
    history: createWebHashHistory(), // createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'root',
            components: {
                default: Dashboard,
            },
            children: [

                
                
                ...ClockRoutes,
                ...ProjectRoutes,
                ...ReportRoutes,
                ...CalendarRoutes,

                ...StaffRoutes,
                ...TimeRoutes,
                ...PartRoutes,
                ...PMRoutes,
                ...ExpenseRoutes,
                ...TechRoutes,
                ...NoteRoutes,
                ...ClientRoutes,
                ...JobRoutes,
                ...MileageRoutes,
                
                ...DashRoutes,
            ]
        },
        

        {
            path: "/logout",
            name: "Logout",
            components: {
                default: Empty,
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Logout
                    }
                }
            ]
        },

        {
            path: "/login",
            name: "Login",
            components: {
                default: Empty,
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Login
                    }
                }
            ]
        },

        {
            path: "/forgot-password",
            name: "Forgot Password",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Forgot
                    }
                }
            ]
        },

        {
            path: "/register",
            name: "Register",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Register
                    }
                }
            ]
        },

        {
            path: "/our-projects",
            name: "Our Projects",
            meta: {
                requiresAuth: true
            },
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: ProjectStatus
                    }
                }
            ]
        },

        {
            path: "/redirect/:to*",
            name: "Redirect",
            component: () => 
            {
                return import("@/components/UI/KtRedirect.vue");
            }
        },

        // Catch-all route for 404 Not Found
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: NotFound
                    }
                }
            ]
        }
    ],
});


router.beforeEach((to, from, next) => {

    console.debug("to", to, "from", from);

    App.initialize();

    

    if (to.meta.requiresAuth) {
        let user = Cache.get("radar_user");

        if (!user) {
            return next("/login");
        }
    }

    const appElement = document.getElementById("app") as HTMLElement | null;
    
    if (appElement)
    {
        // alert(JSON.stringify(to));
        let rt = to.matched && to.matched[0] && to.matched[0].name;
        if (typeof rt === "string")
        {
            rt = rt.replaceAll(/[A-Z]/g, (match) => match.toLowerCase());
            rt = rt.replaceAll(/[^a-z]/g, (match) => "-");
            appElement.className = rt;
        }
        else 
        {
            appElement.className = "nameless";
        }
    }
    return next();
});

// todo ... store the history in the session cache and not local storage

Events.on("redirect", (path:string) => 
{
    path = ("/redirect/" + path + "").replace(/\/\//g, "/");
    window.setTimeout(() =>
    {
        router.push({
            path: path
        });
    }, 30);
});

Events.on("back", () =>
{
    if (historyLength < window.history.length)
    {
        window.setTimeout(() =>
        {
            router.back();
        }, 30);
    }

    else
    {
        // take them to the homepage ?
        router.push({
            path: "/"
        });
    }
});

export default router
